import createApp from './app.js'

import analyticsService from './service.analytics.js'

const appConfig = {"apiKey":"AIzaSyAmBYXl6AxpZn5ng3GlEpSoZxmiuqNc4f0","authDomain":"u-map-fbbfa.firebaseapp.com","projectId":"u-map-fbbfa","storageBucket":"u-map-fbbfa.appspot.com","messagingSenderId":"212558478370","appId":"1:212558478370:web:e1c8902fe743832e181e7b","measurementId":"G-3T46YW8T3X"}

export default async (ctx, inject) => {
  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.client) {
    servicePromises = [
      analyticsService(session, firebase, ctx, inject),

    ]
  }

  const [
    analytics
  ] = await Promise.all(servicePromises)

  const fire = {
    analytics: analytics
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}

function forceInject (ctx, inject, key, value) {
  inject(key, value)
  const injectKey = '$' + key
  ctx[injectKey] = value
  if (typeof window !== "undefined" && window.$nuxt) {
  // If clause makes sure it's only run when ready() is called in a component, not in a plugin.
    window.$nuxt.$options[injectKey] = value
  }
}